import { useNavigate } from 'react-router'
import { baseAPI, useManageWebsiteMutation } from 'api/baseApi'
import { ADMIN_PREFIX_PATH } from 'config'
import { useAppDispatch } from 'hooks'
import { useGlobal } from 'raducer/global'
import { useWebSettings } from 'raducer/webSettings'

export const CHOOSE_TEMPLATE_PATH = `${ADMIN_PREFIX_PATH}/website/choose-template`

// Shared "Manage Website" action:
// matrix_onb true  -> open the website editor link from the API
// matrix_onb false -> go to the template selection page
const useManageWebsite = (): {
 manageWebsite: () => void
 isLoading: boolean
} => {
 const navigate = useNavigate()
 const d = useAppDispatch()
 const { global } = useGlobal()
 const { onboarding_settings } = useWebSettings()
 const { onBoardListingStatus } = onboarding_settings || {}
 const [manageWebsiteMutation, { isLoading }] = useManageWebsiteMutation()

 const manageWebsite = (): void => {
  if (!global?.matrix_onb) {
   navigate(CHOOSE_TEMPLATE_PATH)
   return
  }
  manageWebsiteMutation().then((res: any) => {
   // Refresh onboarding checklist the first time the website is managed
   if (!onBoardListingStatus?.manage_website) {
    d(baseAPI.util.invalidateTags(['WEB-SETTINGS']))
   }
   if (res?.data?.url) {
    window.open(res.data.url, '_blank')
   }
  })
 }

 return { manageWebsite, isLoading }
}

export default useManageWebsite
